module.exports = __webpack_public_path__ + "static/media/blue-logo.cd3db7b5.svg";